__turbopack_context__.v({
  "wrapper": "style-module-scss-module__5Gcq_q__wrapper",
});
